<template>
  <StdPageContainer :class="{ hasmask: red_packet_status != 1 }" type="tabs">
    <template slot="title">
      <!-- 标题栏 -->
      <StdPageTitle :title="$t('lang.k_146001')">
        <div slot="content">
          {{ $t('lang.k_146002') }}
          <br />
          {{ $t('lang.k_146003') }}
          <br />
          {{ $t('lang.k_146004') }}
          <br />
          {{ $t('lang.k_146005') }}
        </div>
        &nbsp;
        <vh-switch
          v-model="red_packet_status"
          :active-value="1"
          @change="protocolChange"
          :inactive-value="0"
          active-color="#FB3A32"
          inactive-color="#CECECE"
          :active-text="redPacketStatusText"
        ></vh-switch>
        <a
          href="https://saas-doc.vhall.com/opendocs/show/1772"
          target="_blank"
          class="tips_link link"
        >
          {{ $t('lang.k_146006') }}
        </a>
      </StdPageTitle>
    </template>

    <!-- 内容区 -->
    <template slot="content">
      <begin-play :webinarId="$route.params.id"></begin-play>
      <vh-dialog
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :title="$t('lang.k_146007')"
        width="400px"
      >
        <div class="cash-redpacket-dialog-content">
          <p>{{ $t('lang.k_146008') }}</p>
          <p>{{ $t('lang.k_146009') }}</p>
          <p>
            {{ $t('lang.k_146010') }}
            <span class="success" v-if="bound_wechat == 1">{{ $t('lang.k_146011') }}</span>
          </p>
          <p>
            {{ $t('lang.k_146012') }}
            <span class="success" v-if="bound_pay_info == 1">{{ $t('lang.k_146013') }}</span>
          </p>
          <p>{{ $t('lang.k_146014') }}</p>
          <p style="margin-top: 10px">
            <a href="https://saas-doc.vhall.com/opendocs/show/1772" target="_blank" class="link">
              {{ $t('lang.k_146015') }}
            </a>
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <vh-button round type="primary" @click="dialogVisible = false">
            {{ $t('lang.k_146016') }}
          </vh-button>
        </span>
      </vh-dialog>
      <!-- tabs -->
      <vh-tabs v-model="activeTab" @tab-click="handleTabClick">
        <vh-tab-pane :label="$t('lang.k_146017')" name="1">
          <RedPacketList
            v-if="activeTab == 1"
            :webinarId="$route.params.id"
            :type="1"
            @edit="toEdit"
            @toRecord="toRecord"
            class="red-packet-list"
          ></RedPacketList>
        </vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_146018')" name="2">
          <RedPacketList
            v-if="activeTab == 2"
            :webinarId="$route.params.id"
            :type="2"
            @edit="toEdit"
            @toRecord="toRecord"
            class="red-packet-list"
          ></RedPacketList>
        </vh-tab-pane>
      </vh-tabs>
    </template>
  </StdPageContainer>
</template>
<script>
  import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
  import { RedPacketList } from '@vhcl/red-packet';
  import { sessionOrLocal } from '@/utils/utils';
  import beginPlay from '@/components/beginBtn';
  export default {
    name: 'CashPacketList',
    components: {
      StdPageContainer,
      StdPageTitle,
      RedPacketList,
      beginPlay
    },
    data() {
      return {
        red_packet_status: 0,
        activeTab: this.$route.query.tab || '1',
        dialogVisible: false,
        bound_pay_info: 0,
        bound_wechat: 0
      };
    },
    computed: {
      redPacketStatusText() {
        return this.$t('lang.k_146019', [
          this.red_packet_status ? this.$t('lang.k_146020') : this.$t('lang.k_146021')
        ]);
      }
    },
    methods: {
      protocolChange(val) {
        this.$fetch('setDurationSwitch', {
          webinar_id: this.$route.params.id,
          permission_key: 'red_packet_status',
          status: val,
          business_uid: JSON.parse(sessionOrLocal.get('userId'))
        })
          .then(res => {
            if (res.code === 200) {
              this.red_packet_status = val;
            } else {
              this.red_packet_status = val == 1 ? 0 : 1;
              this.$message.error(res.msg);
              if (res.code == '513650') {
                this.dialogVisible = true;
                this.bound_pay_info = res.data.bound_pay_info;
                this.bound_wechat = res.data.bound_wechat;
              }
            }
          })
          .catch(error => {
            if (error.code == '513650') {
              this.dialogVisible = true;
              this.bound_pay_info = error.data.bound_pay_info;
              this.bound_wechat = error.data.bound_wechat;
            }
            this.red_packet_status = val == 1 ? 0 : 1;
            this.$message.error(error.msg);
          });
      },
      handleTabClick() {},
      toRecord(data) {
        this.$router.push({
          path: `/live/CashPacket/record/${this.$route.params.id}/${data.id}`
        });
      },
      toEdit(data) {
        this.$router.push({
          path: `/live/CashPacket/edit/${this.$route.params.id}`,
          query: data
            ? {
                id: data.id,
                type: Number(this.activeTab)
              }
            : {
                type: Number(this.activeTab)
              }
        });
      },
      getRedPacketSwitch() {
        this.$fetch('planFunctionGet', {
          webinar_id: this.$route.params.id,
          webinar_user_id: sessionOrLocal.get('userId'),
          scene_id: 1
        }).then(res => {
          if (res.code === 200) {
            this.red_packet_status = JSON.parse(res.data.permissions).red_packet_status;
          }
        });
      }
    },
    created() {
      this.getRedPacketSwitch();
    }
  };
</script>
<style scoped lang="less">
  .tips_link {
    font-size: 14px;
    margin-left: 5px;
  }
  .red-packet-list {
    min-height: 600px;
  }
  .hasmask {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 45px;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
</style>
<style lang="less">
  .cash-redpacket-dialog-content {
    line-height: 22px;
    color: #262626;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;

    .success {
      color: #0fba5a;
    }
  }
</style>
